import { render, staticRenderFns } from "./classRoomManage.vue?vue&type=template&id=3dd403ce&scoped=true"
import script from "./classRoomManage.vue?vue&type=script&lang=js"
export * from "./classRoomManage.vue?vue&type=script&lang=js"
import style0 from "./classRoomManage.vue?vue&type=style&index=0&id=3dd403ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd403ce",
  null
  
)

export default component.exports